(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cf-sticky-cart"] && !Shopify.designMode) return;
  try {
    (() => {
  const readyClass = 'cf-sticky-cart-ready';
  const activeClass = 'cf-sticky-cart-active';
  let scheduled = false;

  function update() {
    scheduled = false;
    const section = document.querySelector('.shopify-section--main-product');
    const bar = section?.querySelector('product-rerender[id$="-sticky-bar"] > product-quick-add');
    const buttons = section?.querySelector('.product-info__buy-buttons');
    if (!bar || !buttons || !bar.querySelector('button[type="submit"]:not([disabled])')) {
      document.body.classList.remove(readyClass, activeClass);
      return;
    }

    document.body.classList.add(readyClass);
    const header = document.querySelector('.shopify-section--header');
    const headerBottom = header ? header.getBoundingClientRect().bottom : 0;
    const pastButton = buttons.getBoundingClientRect().bottom < Math.max(0, headerBottom);
    document.body.classList.toggle(activeClass, pastButton);
  }

  function schedule() {
    if (!scheduled) {
      scheduled = true;
      requestAnimationFrame(update);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', schedule, { once: true });
  } else {
    schedule();
  }
  window.addEventListener('scroll', schedule, { passive: true });
  window.addEventListener('resize', schedule, { passive: true });
  document.addEventListener('shopify:section:load', schedule);
  document.addEventListener('variant:change', schedule);
})();
  } catch(e) { console.error(e); }
})();

})();
